import {StylableComponent,Parent} from "@wm/components-base";
import {Inject, Injectable, Injector, Input, OnInit} from "@angular/core";
import {getEvaluatedData, getOrderedDataset} from "../../../formWidgetUtils";
import {createArrayFrom} from "@wm/core";
import {first, get, isArray, isObject, isUndefined, omitBy, result, startsWith} from "lodash-es";

import {WidgetConfig, IWidgetConfig} from "@wm/components-base";

export interface NavNode{
  label: string;
  action?: any;
  badge?: string;
  children?: Array<NavNode>;
  class?: string;
  disabled?: boolean;
  icon?: string;
  id?: string;
  link?: string;
  role?: string;
  value?: any;
}

const getValidLink = (link: any) => {
  const routRegex = /^(\/|#\/|#)(?!\W).*/;
  if (link) {
    if (routRegex.test(link)) {
      link = first(link.match(/[\w]+.*/g)) || '';
      return `#/${link}`;
    }
    if (startsWith(link, 'www.')) {
      return `//${link}`;
    }
    return link;
  }
};

@Injectable()
export class DatasetAwareNavComponent extends StylableComponent implements  OnInit {
  public nodes: Array<NavNode> = [];
  public _dataset: any;
  public dataset:any
  public itemicon: string;
  public itemlabel: string;
  public itemlink: string;
  public itemtarget: string;
  public itembadge: string;
  public itemchildren: string;
  public itemaction: string;
  public itemclass: string;
  public itemid: string;
  public isactive: string;
  public userrole: string;
  public orderby: string;
  public datafield: string;
  public displayfield: string;

  private _itemFieldMap: any;
  private binditemlabel: string | null;
  private binditemicon: string | null;
  private binditemaction: string | null;
  private binditembadge: string | null;
  private binditemchildren: string | null;
  private binditemlink: string | null;
  private binditemtarget: string | null;
  private binduserrole: string | null;
  private bindisactive: string | null;
  private securityService: any;

  protected binditemid: string | null;
  defaultNodes: any =this.nativeElement.getAttribute('dataset');
  private binddataset: string;

  constructor(inj: Injector,@Inject(WidgetConfig) config: IWidgetConfig, viewParent?: Parent) {
    super(inj, config, viewParent);

    this.binditemlabel = this.nativeElement.getAttribute('itemlabel.bind');
    this.binditemicon = this.nativeElement.getAttribute('itemicon.bind');
    this.binditemaction = this.nativeElement.getAttribute('itemaction.bind');
    this.binditembadge = this.nativeElement.getAttribute('itembadge.bind');
    this.binditemchildren = this.nativeElement.getAttribute('itemchildren.bind');
    this.binditemid = this.nativeElement.getAttribute('itemid.bind');
    this.binditemlink = this.nativeElement.getAttribute('itemlink.bind');
    this.binditemtarget = this.nativeElement.getAttribute('itemtarget.bind');
    this.binduserrole = this.nativeElement.getAttribute('userrole.bind');
    this.bindisactive = this.nativeElement.getAttribute('isactive.bind');
  }


  override ngOnInit() {
    super.ngOnInit()
    this.resetNodes();
  }
  getNode(fields: any, node: any): any{
    const context = this.viewParent;
    const children = getEvaluatedData(node, {field: this.itemchildren, bindExpression: this.binditemchildren}, context) || get(node, fields.childrenField);
    const navNode = {
      action: getEvaluatedData(node, {field: this.itemaction, bindExpression: this.binditemaction}, context) || get(node, fields.actionField),
      badge: getEvaluatedData(node, {field: this.itembadge, bindExpression: this.binditembadge}, context) || get(node, fields.badgeField),
      children: Array.isArray(children) ? this.getNodes(children) : [],
      class: get(node, fields.classField),
      disabled: node.disabled,
      icon: getEvaluatedData(node, {field: this.itemicon, bindExpression: this.binditemicon}, context) || get(node, fields.iconField),
      id: getEvaluatedData(node, {field: this.itemid, bindExpression: this.binditemid}, context) || get(node, fields.idField),
      label: getEvaluatedData(node, {field: this.itemlabel, bindExpression: this.binditemlabel}, context) || get(node, fields.labelField),
      link: getValidLink(getEvaluatedData(node, {field: this.itemlink, bindExpression: this.binditemlink}, context) || get(node, fields.linkField)),
      target: getValidLink(getEvaluatedData(node, {field: this.itemtarget, bindExpression: this.binditemtarget}, context) || get(node, fields.targetField)),
      role: getEvaluatedData(node, {field: this.userrole, bindExpression: this.binduserrole}, context),
      isactive: getEvaluatedData(node, {field: this.isactive, bindExpression: this.bindisactive}, context),
      // older projects have display field & data field property for menu.
      // value: this.datafield ? (this.datafield === 'All Fields' ? node : findValueOf(node, this.datafield)) : node
    };
    return omitBy(navNode, isUndefined);
  }

  getNodes(nv: any = this.dataset || {}){
    nv = startsWith(this.binddataset, 'bind:')? this.defaultNodes: nv;
    let nodes: Array<any> = getOrderedDataset(this.prepareNodeDataSet(nv), this.orderby) || [];
    return nodes;
  }

  prepareNodeDataSet(nv:any){
    nv = createArrayFrom(nv);
    if (isArray(nv)){
      return nv.map((val: any) => {
        if (!isObject(val)) {
          return {
            label : val,
            value : val
          };
        }
        return val;
      })
    }
    return;
  }

  getItemFieldsMap() {
    if (!this._itemFieldMap) {
      this._itemFieldMap = {
        idField: this.itemid || 'itemid',
        iconField: this.itemicon || 'icon',
        labelField: this.itemlabel || 'label',
        linkField: this.itemlink || 'link',
        targetField: this.itemtarget || 'target',
        badgeField: this.itembadge || 'badge',
        childrenField: this.itemchildren || 'children',
        classField: this.itemclass || 'class',
        actionField: this.itemaction || 'action',
        isactiveField: this.isactive || 'isactive'
      };
    }
    console.log(this._itemFieldMap)
    return this._itemFieldMap;
  }

  resetNodes() {
    this.resetItemFieldMap();
    this.nodes = this.getNodes();
  }

  resetItemFieldMap() {
    this._itemFieldMap = null;
  }

 protected override onPropertyChange(key: string, nv: any, ov?: any) {
    switch (key) {
      case 'dataset':
      case 'itemicon':
      case 'itemlabel':
      case 'itemlink':
      case 'itemtarget':
      case 'itemclass':
      case 'itemchildren':
      case 'isactive':
      case 'orderby':
        // calls resetnodes method after 50ms. any calls within 50ms will be ignored.
        this.resetNodes();
        break;
    }
    super.onPropertyChange(key, nv, ov);
  }
}

